const _404 = resolve => require(['@/components/pages/404.vue'], resolve)
const Login = resolve => require(['@/components/pages/Login.vue'], resolve)
const Dashboard = resolve => require(['@/components/pages/Dashboard.vue'], resolve)
const Changelog = resolve => require(['@/components/pages/Changelog.vue'], resolve)
const CustomerList = resolve => require(['@/components/pages/customers/List.vue'], resolve)
const ContactEdit = resolve => require(['@/components/pages/contacts/Edit.vue'], resolve)
const CustomerDetails = resolve => require(['@/components/pages/customers/Details.vue'], resolve)
const VehicleList = resolve => require(['@/components/pages/vehicles/List.vue'], resolve)
const VehicleEdit = resolve => require(['@/components/pages/vehicles/Edit.vue'], resolve)
const JobEdit = resolve => require(['@/components/pages/jobs/Edit.vue'], resolve)
const JobDetails = resolve => require(['@/components/pages/jobs/Details.vue'], resolve)
const SupplierDetails = resolve => require(['@/components/pages/suppliers/Details.vue'], resolve)
const SupplierList = resolve => require(['@/components/pages/suppliers/List.vue'], resolve)
const SupplierAccountsList = resolve => require(['@/components/pages/suppliers/AccountList.vue'], resolve)
const ProductEdit = resolve => require(['@/components/pages/products/Edit.vue'], resolve)
const ProductList = resolve => require(['@/components/pages/products/List.vue'], resolve)
const ProductDetails = resolve => require(['@/components/pages/products/Details.vue'], resolve)
const JobList = resolve => require(['@/components/pages/jobs/List.vue'], resolve)
const InvoiceList = resolve => require(['@/components/pages/invoices/List.vue'], resolve)
const InvoiceEdit = resolve => require(['@/components/pages/invoices/Edit.vue'], resolve)
const CreditNoteList = resolve => require(['@/components/pages/credit-notes/List.vue'], resolve)
const CreditNoteEdit = resolve => require(['@/components/pages/credit-notes/Edit.vue'], resolve)
const VehicleDetails = resolve => require(['@/components/pages/vehicles/Details.vue'], resolve)
const ReminderEdit = resolve => require(['@/components/pages/reminders/Edit.vue'], resolve)
const ReminderList = resolve => require(['@/components/pages/reminders/List.vue'], resolve)
const ReminderDetails = resolve => require(['@/components/pages/reminders/Details.vue'], resolve)
const ReminderListEdit = resolve => require(['@/components/pages/reminders/list/Edit.vue'], resolve)
const ReminderListList = resolve => require(['@/components/pages/reminders/list/List.vue'], resolve)
const ProfileDetails = resolve => require(['@/components/pages/profile/Details.vue'], resolve)
const ProfileEdit = resolve => require(['@/components/pages/profile/Edit.vue'], resolve)
const PaymentList = resolve => require(['@/components/pages/payments/List.vue'], resolve)
const ReportsAccountingLinks = resolve => require(['@/components/pages/reports/AccountingLinks.vue'], resolve)
const ReportsPayments = resolve => require(['@/components/pages/reports/Payments.vue'], resolve)
const ReportsProducts = resolve => require(['@/components/pages/reports/Products.vue'], resolve)
const ReportsAgeingOfAccounts = resolve => require(['@/components/pages/reports/AgeingOfAccounts.vue'], resolve)
const ReceiptDetails = resolve => require(['@/components/pages/receipts/Details.vue'], resolve)
const ReceiptList = resolve => require(['@/components/pages/receipts/List.vue'], resolve)
const Administration = resolve => require(['@/components/pages/administration/Administration.vue'], resolve)
const Settings = resolve => require(['@/components/pages/administration/Settings.vue'], resolve)
const Users = resolve => require(['@/components/pages/administration/users/Users.vue'], resolve)
const UserList = resolve => require(['@/components/pages/administration/users/List.vue'], resolve)
const UserDetails = resolve => require(['@/components/pages/administration/users/Details.vue'], resolve)
const UserEdit = resolve => require(['@/components/pages/administration/users/Edit.vue'], resolve)
const FinancialAccounts = resolve => require(['@/components/pages/administration/financialAccounts/FinancialAccounts.vue'], resolve)
const FinancialAccountList = resolve => require(['@/components/pages/administration/financialAccounts/List.vue'], resolve)
const FinancialAccountDetails = resolve => require(['@/components/pages/administration/financialAccounts/Details.vue'], resolve)
const FinancialAccountEdit = resolve => require(['@/components/pages/administration/financialAccounts/Edit.vue'], resolve)
const FinancialAccountTransfer = resolve => require(['@/components/pages/administration/financialAccounts/Transfer.vue'], resolve)
const FinancialAccountListTransfer = resolve => require(['@/components/pages/administration/financialAccounts/ListTransfers.vue'], resolve)

export default [
  {
    path: '*',
    name: '404',
    meta: {
      auth: false,
    },
    component: _404
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      auth: false,
      title: 'Login',
    },
    component: Login
  },
  {
    path: '/',
    name: 'dashboard',
    meta: {
      auth: true,
      title: 'Dashboard',
    },
    component: Dashboard
  },
  {
    path: '/changelog',
    name: 'changelog',
    meta: {
      auth: true,
      title: 'Changelog',
      containerType: 'boxed',
    },
    component: Changelog
  },
  {
    path: '/customer/list',
    name: 'customer.list',
    meta: {
      auth: {
        permissions: {
          allow: ['customer.view']
        }
      },
      title: 'List Customers',
    },
    component: CustomerList
  },
  {
    path: '/customer/create',
    name: 'customer.create',
    meta: {
      auth: {
        permissions: {
          allow: ['customer.create']
        }
      },
      title: 'Create Customer',
    },
    component: ContactEdit
  },
  {
    path: '/customer/edit/:contactID',
    name: 'customer.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['customer.edit']
        }
      },
      title: 'Edit Customer',
    },
    component: ContactEdit
  },
  {
    path: '/customer/details/:customerID',
    name: 'customer.details',
    meta: {
      auth: {
        permissions: {
          allow: ['customer.view']
        }
      },
      title: 'Customer details',
    },
    component: CustomerDetails
  },
  {
    path: '/vehicle/list',
    name: 'vehicle.list',
    meta: {
      auth: {
        permissions: {
          allow: ['vehicle.view']
        }
      },
      title: 'List vehicles',
    },
    component: VehicleList
  },
  {
    path: '/vehicle/create',
    name: 'vehicle.create',
    meta: {
      auth: {
        permissions: {
          allow: ['vehicle.create']
        }
      },
      title: 'Create Vehicle',
    },
    component: VehicleEdit
  },
  {
    path: '/vehicle/edit/:vehicleID',
    name: 'vehicle.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['vehicle.edit']
        }
      },
      title: 'Edit vehicle',
    },
    component: VehicleEdit
  },
  {
    path: '/vehicle/details/:vehicleID',
    name: 'vehicle.details',
    meta: {
      auth: {
        permissions: {
          allow: ['vehicle.view']
        }
      },
      title: 'Vehicle details',
    },
    component: VehicleDetails
  },
  {
    path: '/job/create',
    name: 'job.create',
    meta: {
      auth: {
        permissions: {
          allow: ['job.create']
        }
      },
      title: 'Create job',
    },
    component: JobEdit
  },
  {
    path: '/job/edit/:jobID',
    name: 'job.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['job.edit']
        }
      },
      title: 'Edit job',
    },
    component: JobEdit
  },
  {
    path: '/job/details/:jobID',
    name: 'job.details',
    meta: {
      auth: {
        permissions: {
          allow: ['job.edit']
        }
      },
      title: 'Job details',
    },
    component: JobDetails
  },
  {
    path: '/job/list',
    name: 'job.list',
    meta: {
      auth: {
        permissions: {
          allow: ['job.view']
        }
      },
      title: 'List jobs',
    },
    component: JobList
  },
  {
    path: '/supplier/create/accounts',
    name: 'supplier.create.accounts',
    meta: {
      auth: {
        permissions: {
          allow: ['supplier.create']
        }
      },
      title: 'Create supplier',
    },
    component: ContactEdit
  },
  {
    path: '/supplier/edit/:supplierID',
    name: 'supplier.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['supplier.edit']
        }
      },
      title: 'Edit supplier',
    },
    component: ContactEdit
  },
  {
    path: '/supplier/list',
    name: 'supplier.list',
    meta: {
      auth: {
        permissions: {
          allow: ['supplier.view']
        }
      },
      title: 'List suppliers',
    },
    component: SupplierList
  },
  {
    path: '/supplier/details/:supplierID',
    name: 'supplier.details',
    meta: {
      auth: {
        permissions: {
          allow: ['supplier.view']
        }
      },
      title: 'Edit supplier',
    },
    component: SupplierDetails
  },
  {
    path: '/supplier/account/list',
    name: 'supplierAccount.list',
    meta: {
      auth: {
        permissions: {
          allow: ['supplier-account.view']
        }
      },
      title: 'List supplier accounts',
    },
    component: SupplierAccountsList
  },
  {
    path: '/product/create',
    name: 'product.create',
    meta: {
      auth: {
        permissions: {
          allow: ['product.create']
        }
      },
      title: 'Create product',
    },
    component: ProductEdit
  },
  {
    path: '/product/edit/:productID',
    name: 'product.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['product.edit']
        }
      },
      title: 'Edit product',
    },
    component: ProductEdit
  },
  {
    path: '/product/list',
    name: 'product.list',
    meta: {
      auth: {
        permissions: {
          allow: ['product.view']
        }
      },
      title: 'List product',
    },
    component: ProductList
  },
  {
    path: '/product/details/:productID',
    name: 'product.details',
    meta: {
      auth: {
        permissions: {
          allow: ['product.view']
        }
      },
      title: 'Product details',
    },
    component: ProductDetails
  },
  {
    path: '/invoice/list',
    name: 'invoice.list',
    meta: {
      auth: {
        permissions: {
          allow: ['invoice.view']
        }
      },
      title: 'List invoice',
    },
    component: InvoiceList
  },
  {
    path: '/invoice/create',
    name: 'invoice.create',
    meta: {
      auth: {
        permissions: {
          allow: ['invoice.create']
        }
      },
      title: 'Create invoice',
      containerType: 'boxed',
    },
    component: InvoiceEdit
  },
  {
    path: '/invoice/edit/:invoiceID',
    name: 'invoice.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['invoice.edit']
        }
      },
      title: 'Edit invoice',
      containerType: 'boxed',
    },
    component: InvoiceEdit
  },
  {
    path: '/invoice/preview/:invoiceID',
    name: 'invoice.preview',
    meta: {
      auth: {
        permissions: {
          allow: ['invoice.view']
        }
      },
      title: 'Invoice preview',
      containerType: 'boxed',
    },
    component: InvoiceEdit
  },
  {
    path: '/credit-note/list',
    name: 'credit-note.list',
    meta: {
      auth: {
        permissions: {
          allow: ['credit-note.view']
        }
      },
      title: 'List credit notes',
    },
    component: CreditNoteList
  },
  {
    path: '/credit-note/edit/:creditNoteID',
    name: 'credit-note.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['credit-note.edit']
        }
      },
      title: 'Edit credit note',
      containerType: 'boxed',
    },
    component: CreditNoteEdit
  },
  {
    path: '/credit-note/preview/:creditNoteID',
    name: 'credit-note.preview',
    meta: {
      auth: {
        permissions: {
          allow: ['credit-note.view']
        }
      },
      title: 'Credit note preview',
      containerType: 'boxed',
    },
    component: CreditNoteEdit
  },
  {
    path: '/reminder/create',
    name: 'reminder.create',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder.create']
        }
      },
      title: 'Create reminder',
    },
    component: ReminderEdit
  },
  {
    path: '/reminder/edit/:reminderID',
    name: 'reminder.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder.edit']
        }
      },
      title: 'Reminder edit',
    },
    component: ReminderEdit
  },
  {
    path: '/reminder/list',
    name: 'reminder.list',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder.view']
        }
      },
      title: 'List reminders',
    },
    component: ReminderList
  },
  {
    path: '/reminder/details/:reminderID',
    name: 'reminder.details',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder.view']
        }
      },
      title: 'Reminder details',
    },
    component: ReminderDetails
  },
  {
    path: '/reminder-list/create',
    name: 'reminder-list.create',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder-list.view']
        }
      },
      title: 'Create reminder list',
    },
    component: ReminderListEdit
  },
  {
    path: '/reminder-list/edit/:listID',
    name: 'reminder-list.edit',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder-list.edit']
        }
      },
      title: 'Reminder list edit',
    },
    component: ReminderListEdit
  },
  {
    path: '/reminder-list/list',
    name: 'reminder-list.list',
    meta: {
      auth: {
        permissions: {
          allow: ['reminder-list.view']
        }
      },
      title: 'Reminder Lists',
    },
    component: ReminderListList
  },
  {
    path: '/profile/details',
    name: 'profile.details',
    meta: {
      auth: true,
      title: 'User Profile Details',
      containerType: 'boxed',
    },
    component: ProfileDetails,
  },
  {
    path: '/profile/edit',
    name: 'profile.edit',
    meta: {
      auth: true,
      title: 'Edit User Profile',
      containerType: 'boxed',
    },
    component: ProfileEdit,
  },
  {
    path: '/payment/list',
    name: 'payment.list',
    meta: {
      auth: {
        permissions: {
          allow: ['payment.view']
        }
      },
      title: 'List payments',
    },
    component: PaymentList
  },
  {
    path: '/report/accounting-links',
    name: 'report.accounting-links',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Accounting',
    },
    component: ReportsAccountingLinks
  },
  {
    path: '/report/payments',
    name: 'report.payments',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Payments',
    },
    component: ReportsPayments
  },
  {
    path: '/report/products',
    name: 'report.products',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Products',
    },
    component: ReportsProducts
  },
  {
    path: '/report/ageing-of-accounts',
    name: 'report.ageing-of-accounts',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Ageing of accounts',
    },
    component: ReportsAgeingOfAccounts
  },
  {
    path: '/report/accounting/sales-unsettled-credit-invoices',
    name: 'report.accounting.sales-unsettled-credit-invoices',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Sales Unsettled Credit Invoices',
      filters: {
        cash_on_delivery: {
          active: false,
          value: false,
        },
        settled: {
          active: false,
          value: false,
        },
        type: {
          active: false,
          value: 'sales',
        },
      }
    },
    component: InvoiceList
  },
  {
    path: '/report/accounting/sales-cash-invoices',
    name: 'report.accounting.sales-cash-invoices',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Sales Cash Invoices',
      filters: {
        cash_on_delivery: {
          active: false,
          value: true,
        },
        settled: {
          active: false,
          value: true,
        },
        type: {
          active: false,
          value: 'sales',
        },
      }
    },
    component: InvoiceList
  },
  {
    path: '/report/accounting/sales-settled-credit-invoices',
    name: 'report.accounting.sales-settled-credit-invoices',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Sales Settled Credit Invoices',
      filters: {
        cash_on_delivery: {
          active: false,
          value: false,
        },
        settled: {
          active: false,
          value: true,
        },
        type: {
          active: false,
          value: 'sales',
        },
      }
    },
    component: InvoiceList
  },
  {
    path: '/report/accounting/sales-settled-credit-notes',
    name: 'report.accounting.sales-settled-credit-notes',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Sales Settled Credit Notes',
      filters: {
        settled: {
          active: false,
          value: true,
        },
        type: {
          active: false,
          value: 'sales',
        },
      }
    },
    component: CreditNoteList
  },
  {
    path: '/report/accounting/sales-unsettled-credit-notes',
    name: 'report.accounting.sales-unsettled-credit-notes',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Sales Unsettled Credit Notes',
      filters: {
        settled: {
          active: false,
          value: false,
        },
        type: {
          active: false,
          value: 'sales',
        },
      }
    },
    component: CreditNoteList
  },
  {
    path: '/report/accounting/purchases-unsettled-credit-invoices',
    name: 'report.accounting.purchases-unsettled-credit-invoices',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Purchases Unsettled Credit Invoices',
      filters: {
        cash_on_delivery: {
          active: false,
          value: false,
        },
        settled: {
          active: false,
          value: false,
        },
        type: {
          active: false,
          value: 'purchases',
        },
      }
    },
    component: InvoiceList
  },
  {
    path: '/report/accounting/purchases-cash-invoices',
    name: 'report.accounting.purchases-cash-invoices',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Purchases Cash Invoices',
      filters: {
        cash_on_delivery: {
          active: false,
          value: true,
        },
        settled: {
          active: false,
          value: true,
        },
        type: {
          active: false,
          value: 'purchases',
        },
      }
    },
    component: InvoiceList
  },
  {
    path: '/report/accounting/purchases-settled-credit-invoices',
    name: 'report.accounting.purchases-settled-credit-invoices',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Purchases Settled Credit Invoices',
      filters: {
        cash_on_delivery: {
          active: false,
          value: false,
        },
        settled: {
          active: false,
          value: true,
        },
        type: {
          active: false,
          value: 'purchases',
        },
      }
    },
    component: InvoiceList
  },
  {
    path: '/report/accounting/purchases-settled-credit-notes',
    name: 'report.accounting.purchases-settled-credit-notes',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Purchases Settled Credit Notes',
      filters: {
        settled: {
          active: false,
          value: true,
        },
        type: {
          active: false,
          value: 'purchases',
        },
      }
    },
    component: CreditNoteList
  },
  {
    path: '/report/accounting/purchases-unsettled-credit-notes',
    name: 'report.accounting.purchases-unsettled-credit-notes',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Purchases Unsettled Credit Notes',
      filters: {
        settled: {
          active: false,
          value: false,
        },
        type: {
          active: false,
          value: 'purchases',
        },
      }
    },
    component: CreditNoteList
  },
  {
    path: '/report/accounting/sales-receipts',
    name: 'report.accounting.sales-receipts',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Sales Receipts',
      filters: {
        type: {
          active: false,
          value: 'sales',
        },
      }
    },
    component: ReceiptList
  },
  {
    path: '/report/accounting/purchases-receipts',
    name: 'report.accounting.purchases-receipts',
    meta: {
      auth: {
        permissions: {
          allow: ['report.view']
        }
      },
      title: 'Reports - Purchases Receipts',
      filters: {
        type: {
          active: false,
          value: 'purchases',
        },
      }
    },
    component: ReceiptList
  },
  {
    path: '/receipt/details/:receiptID',
    name: 'receipt.details',
    meta: {
      auth: {
        permissions: {
          allow: ['receipt.view']
        }
      },
      title: 'Receipt Details',
    },
    component: ReceiptDetails
  },
  {
    path: '/receipt/list',
    name: 'receipt.list',
    meta: {
      auth: {
        permissions: {
          allow: ['receipt.view']
        }
      },
      title: 'Receipt List',
    },
    component: ReceiptList
  },
  // Administration routes:
  {
    path: '/administration',
    name: 'administration',
    meta: {
      auth: true,
      title: 'Administration',
    },
    component: Administration,
    children: [
      {
        path: 'settings',
        name: 'administration.settings',
        meta: {
          auth: {
            permissions: {
              allow: ['site-settings.edit']
            }
          },
          parent: true,
          title: 'Settings',
          icon: 'fas fa-tools',
        },
        component: Settings,
        children: [
          {
            path: 'general',
            name: 'administration.settings.general',
            meta: {
              title: 'General',
            },
          },
          {
            path: 'company',
            name: 'administration.settings.company',
            meta: {
              title: 'Company',
            },
          },
          {
            path: 'reminders',
            name: 'administration.settings.reminders',
            meta: {
              title: 'Reminders',
            },
          },
          {
            path: 'images',
            name: 'administration.settings.images',
            meta: {
              title: 'Images',
            },
          },
        ]
      },
      {
        path: 'user',
        name: 'administration.user',
        meta: {
          auth: true,
          parent: true,
          title: 'Users',
          icon: 'fas fa-users',
        },
        component: Users,
        children: [
          {
            path: 'list',
            name: 'administration.user.list',
            meta: {
              auth: {
                permissions: {
                  allow: ['user.view']
                }
              },
              title: 'List',
            },
            component: UserList,
          },
          {
            path: 'details/:userID',
            name: 'administration.user.details',
            meta: {
              auth: {
                permissions: {
                  allow: ['user.view']
                },
              },
              title: 'Details',
              nav: false,
            },
            component: UserDetails,
          },
          {
            path: 'edit/:userID',
            name: 'administration.user.edit',
            meta: {
              auth: {
                permissions: {
                  allow: ['user.edit']
                },
              },
              title: 'Edit',
              nav: false,
            },
            component: UserEdit,
          },
          {
            path: 'create',
            name: 'administration.user.create',
            meta: {
              auth: {
                permissions: {
                  allow: ['user.create']
                },
              },
              title: 'Create',
            },
            component: UserEdit,
          },
        ]
      },
      {
        path: 'financial-account',
        name: 'administration.financial-account',
        meta: {
          auth: true,
          parent: true,
          title: 'Financial accounts',
          // icon: 'fe-dollar-sign',
          icon: 'fas fa-book-open',
        },
        component: FinancialAccounts,
        children: [
          {
            path: 'list',
            name: 'administration.financial-account.list',
            meta: {
              auth: {
                permissions: {
                  allow: ['financial-account.view']
                },
              },
              title: 'List',
            },
            component: FinancialAccountList,
          },
          {
            path: 'details/:accountID',
            name: 'administration.financial-account.details',
            meta: {
              auth: {
                permissions: {
                  allow: ['financial-account.view']
                },
              },
              title: 'Details',
              nav: false,
            },
            component: FinancialAccountDetails,
          },
          {
            path: 'edit/:accountID',
            name: 'administration.financial-account.edit',
            meta: {
              auth: {
                permissions: {
                  allow: ['financial-account.edit']
                },
              },
              title: 'Edit',
              nav: false,
            },
            component: FinancialAccountEdit,
          },
          {
            path: 'create',
            name: 'administration.financial-account.create',
            meta: {
              auth: {
                permissions: {
                  allow: ['financial-account.create']
                },
              },
              title: 'Create',
            },
            component: FinancialAccountEdit,
          },
          {
            path: 'transfer',
            name: 'administration.financial-account.transfer',
            meta: {
              auth: {
                permissions: {
                  allow: ['financial-transfer.create']
                },
              },
              title: 'Transfer',
            },
            component: FinancialAccountTransfer,
          },
          {
            path: 'list-transfers',
            name: 'administration.financial-account.list-transfers',
            meta: {
              auth: {
                permissions: {
                  allow: ['financial-transfer.view']
                },
              },
              title: 'List transfers',
            },
            component: FinancialAccountListTransfer,
          },
        ]
      },
    ]
  }
]
